import { c as _c } from "react/compiler-runtime";
import { useCallback, useRef, useState } from 'react';
import { ProductMedium } from '@spa/components/product-info/product-media/product-medium';
const SWIPE_THRESHOLD = 50;
const FLICK_VELOCITY = 0.3;
const EDGE_RESISTANCE = 3;
export interface Slide {
  readonly item: ProductMedium;
  readonly index: number;
}
export interface MediaSwipe {
  readonly visibleSlides: ReadonlyArray<Slide>;
  readonly isSwiping: boolean;
  readonly getSlideTransform: (index: number) => string;
  readonly isActive: () => boolean;
  readonly track: (deltaX: number) => void;
  readonly stop: () => void;
  readonly release: (deltaX: number, deltaY: number, wrapperWidth: number, duration: number) => boolean;
}
interface Params {
  readonly media: ReadonlyArray<ProductMedium>;
  readonly currentMainMedia: number;
  readonly goToImage: (imageIndex: number) => void;
}
const isSwipe = (deltaX: number, deltaY: number, wrapperWidth: number, duration: number): boolean => {
  const distance: number = Math.abs(deltaX);
  const isFlick: boolean = distance >= SWIPE_THRESHOLD && distance / Math.max(duration, 1) >= FLICK_VELOCITY;
  return distance > Math.abs(deltaY) && (distance >= wrapperWidth / 2 || isFlick);
};
export default function useMediaSwipe(t0) {
  const $ = _c(22);
  const {
    media,
    currentMainMedia,
    goToImage
  } = t0;
  const swipingRef = useRef(false);
  const [dragOffset, setDragOffset] = useState(0);
  const [isSwiping, setIsSwiping] = useState(false);
  let t1;
  if ($[0] !== currentMainMedia || $[1] !== media) {
    let t2;
    if ($[3] !== currentMainMedia) {
      t2 = t3 => {
        const {
          index: index_0
        } = t3;
        return Math.abs(index_0 - currentMainMedia) <= 1;
      };
      $[3] = currentMainMedia;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = media.map(_temp).filter(t2);
    $[0] = currentMainMedia;
    $[1] = media;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const visibleSlides = t1;
  let t2;
  if ($[5] !== currentMainMedia || $[6] !== dragOffset) {
    t2 = index_1 => {
      const slideOffset = `translateX(${(index_1 - currentMainMedia) * 100}%)`;
      return dragOffset === 0 ? slideOffset : `${slideOffset} translateX(${dragOffset}px)`;
    };
    $[5] = currentMainMedia;
    $[6] = dragOffset;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const getSlideTransform = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => swipingRef.current;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const isActive = t3;
  let t4;
  if ($[9] !== currentMainMedia || $[10] !== media.length) {
    t4 = deltaX => {
      const hasTargetImage = deltaX < 0 ? currentMainMedia < media.length - 1 : currentMainMedia > 0;
      swipingRef.current = true;
      setDragOffset(Math.round(hasTargetImage ? deltaX : deltaX / EDGE_RESISTANCE));
      setIsSwiping(true);
    };
    $[9] = currentMainMedia;
    $[10] = media.length;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const track = t4;
  let t5;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => {
      swipingRef.current = false;
      setDragOffset(0);
      setIsSwiping(false);
    };
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const stop = t5;
  let t6;
  if ($[13] !== currentMainMedia || $[14] !== goToImage) {
    t6 = (deltaX_0, deltaY, wrapperWidth, duration) => {
      if (!isSwipe(deltaX_0, deltaY, wrapperWidth, duration)) {
        return false;
      }
      goToImage(deltaX_0 < 0 ? currentMainMedia + 1 : currentMainMedia - 1);
      return true;
    };
    $[13] = currentMainMedia;
    $[14] = goToImage;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const release = t6;
  let t7;
  if ($[16] !== getSlideTransform || $[17] !== isSwiping || $[18] !== release || $[19] !== track || $[20] !== visibleSlides) {
    t7 = {
      visibleSlides,
      isSwiping,
      getSlideTransform,
      isActive,
      track,
      stop,
      release
    };
    $[16] = getSlideTransform;
    $[17] = isSwiping;
    $[18] = release;
    $[19] = track;
    $[20] = visibleSlides;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function _temp(item, index) {
  return {
    item,
    index
  };
}